import { FlowConditionEmailOpened } from './types.flow';

import { asEmailPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/Email';

export default (condition: any): Omit<FlowConditionEmailOpened, 'id'> => ({
  type: 'Flow_Condition_Event_Email_Opened',
  email: asEmailPointerParameterValue(condition.email),
});
